import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import * as PATH from './path';

import TagManager from 'react-gtm-module';

import { AuthProvider } from '../../modules/contexts/Auth';
import { DrawerProvider } from '../../modules/contexts/DrawerContext';
import { ReviewProvider } from '../../modules/contexts/Review';
import { ImageFileProvider } from '../../modules/contexts/ImageFile';
import { PromotionModalProvider } from '../../modules/contexts/PromotionModalContext';
import { DeadlineModalProvider } from '../../modules/contexts/DeadlineModalContext';
import { ModalProvider } from '../../modules/contexts/Modalcontext';
import { AffiliateProvider } from '../../modules/contexts/AffiliateContext'

import {
  SigninPage,
  SignupPage,
  SignupSnsPage,
  FindPage,
  PasswordResetPage,
  OrderPage,
  CompletionPage,
  PresentPage,
  NaverCallbackPage,
  KakaoCallbackPage,
  InfoPage,
  NotFoundPage,
  MyPage,
  EventMainPage,
  EventDetailPage,
  BrandStoryPage,
  HomePage,
} from '../../pages';
import Babyface from '../../domain/Sales/Item/Babyface';
import Clearface from '../../domain/Sales/ClearfaceItem/Clearface';
import ReviewRoute from './ReviewRoute';
import Order from '../../domain/order/Order';
import PrePurchase from '../../domain/order/PrePurchase/PrePurchase';
import { checkAuth } from '../util/Authenticate';
import BlogPage from '../../pages/BlogPage';
import HeRoutes from './HeRoutes';

const tagManagerArgs = {
  gtmId: 'GTM-W5TRNGL',
};

TagManager.initialize(tagManagerArgs);

export const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      // 모바일 결제 완료 후 리다이렉트 시 인증 체크 우회
      // imp_success 파라미터가 있으면 결제 완료 상태이므로 인증 불필요
      const queryParams = new URLSearchParams(props.location.search);
      const isPaymentCompletion = queryParams.get('imp_success') === 'true';
      
      if (isPaymentCompletion) {
        return <Component {...props} />;
      }
      
      return checkAuth(true) ? <Component {...props} /> : <Redirect to={PATH.SIGNIN} />;
    }}
  />
);

export const BABYFACE_URL = `${process.env.REACT_APP_BACKEND_URL}`;

const AppProvider = ({ contexts, children }) =>
  contexts.reduce(
    (prev, context) =>
      React.createElement(context, {
        children: prev,
      }),
    children,
  );

class Routes extends Component {
  render() {
    return (
      <AppProvider
        contexts={[
          AuthProvider,
          DrawerProvider,
          ReviewProvider,
          ImageFileProvider,
          PromotionModalProvider,
          DeadlineModalProvider,
          ModalProvider,
          AffiliateProvider,
        ]}
      >
        <Switch>
          <Route exact path={PATH.HOME} component={HomePage} />
          <Route exact path={PATH.SIGNIN} component={SigninPage} />
          <Route exact path={PATH.SIGNIN_NAVER} component={NaverCallbackPage} />
          <Route exact path={`${PATH.SIGNIN_NAVER}/redirect`} component={NaverCallbackPage} />
          <Route exact path={PATH.SIGNIN_KAKAO} component={KakaoCallbackPage} />
          <Route exact path={PATH.SIGNUP} component={SignupPage} />
          <Route exact path={PATH.SIGNUP_SNS} component={SignupSnsPage} />
          <Route exact path={PATH.FIND} component={FindPage} />
          <Route
            exact
            path={`${PATH.PASSWORD_RESET}/:code`}
            component={PasswordResetPage}
          />
          <Route exact path={PATH.SALES} component={Babyface} />
          <Route exact path={PATH.SALES_CLEARFACE} component={Clearface} />
          <AuthRoute exact path={PATH.ORDER} component={OrderPage} />
          <AuthRoute exact path={PATH.ORDER_CLEARFACE} component={Order} />
          {/* 결제 완료 페이지는 인증 불필요 (paymentKey로 조회 가능, 모바일 세션 만료 대응) */}
          <Route
            exact
            path={`${PATH.COMPLETION}/:id`}
            component={CompletionPage}
          />
          <AuthRoute exact path={PATH.ORDER_PRESENT} component={PresentPage} />
          <AuthRoute
            exact
            path={PATH.ORDER_PRE_PURCHASE}
            component={PrePurchase}
          />
          <Route path={PATH.EVENT} component={EventMainPage} />
          <Route
            exact
            path={`${PATH.EVENT_DETAIL}/:event`}
            component={EventDetailPage}
          />
          <Route path={PATH.INFO} component={InfoPage} />
          <Route path={PATH.REVIEW} component={ReviewRoute} />
          <AuthRoute path={PATH.MYPAGE} component={MyPage} />
          <Route path={PATH.BRAND_STORY} component={BrandStoryPage} />
          <Route path={PATH.BLOG} component={BlogPage} />
          <Route path={PATH.HE} component={HeRoutes} />
          <Route component={NotFoundPage} />
        </Switch>
      </AppProvider>
    );
  }
}

export default Routes;
